import { render } from "./pay.vue?vue&type=template&id=27aa66ed&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"

import "./pay.vue?vue&type=style&index=0&id=27aa66ed&scoped=true&lang=css"
import "./pay.vue?vue&type=style&index=1&id=27aa66ed&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-27aa66ed"

export default script